import React from "react";

const ccamFlag = () => {
  return (
    <div className="ccam-flag">
      <span>CCAM Flag</span>
    </div>
  );
}

export default ccamFlag;
